import MuiTable, { TableProps } from "@mui/material/Table";
import MuiTableBody, { TableBodyProps } from "@mui/material/TableBody";
import MuiTableCell, { TableCellProps } from "@mui/material/TableCell";
import MuiTableContainer, {
  TableContainerProps,
} from "@mui/material/TableContainer";
import MuiTableHead, { TableHeadProps } from "@mui/material/TableHead";
import MuiTableRow, { TableRowProps } from "@mui/material/TableRow";
import { getStyleProps } from "modules/themes/styleUtils";

export const Table = (props: TableProps) => {
  return (
    <MuiTable {...props} {...getStyleProps(props)}>
      {props.children}
    </MuiTable>
  );
};

export const TableBody = (props: TableBodyProps) => {
  return (
    <MuiTableBody {...props} {...getStyleProps(props)}>
      {props.children}
    </MuiTableBody>
  );
};

export const TableCell = (props: TableCellProps) => {
  return (
    <MuiTableCell {...props} {...getStyleProps(props)}>
      {props.children}
    </MuiTableCell>
  );
};

export const TableContainer = (props: TableContainerProps) => {
  return (
    <MuiTableContainer {...props} {...getStyleProps(props)}>
      {props.children}
    </MuiTableContainer>
  );
};

export const TableHead = (props: TableHeadProps) => {
  return (
    <MuiTableHead {...props} {...getStyleProps(props)}>
      {props.children}
    </MuiTableHead>
  );
};
export const TableRow = (props: TableRowProps) => {
  return (
    <MuiTableRow {...props} {...getStyleProps(props)}>
      {props.children}
    </MuiTableRow>
  );
};
